import {
  FileXls,
  Table,
  CloudArrowDown,
  Funnel,
  ArrowsDownUp,
  Calculator,
  Copy,
  ChartBar,
  SquaresFour,
  ArrowsMerge,
  Stack,
  ArrowsLeftRight,
  DownloadSimple,
} from '@phosphor-icons/react';
import type { FC } from 'react';

export type PhosphorIconProps = {
  className?: string;
  weight?: 'thin' | 'light' | 'regular' | 'bold' | 'fill' | 'duotone';
};

export type NodeIconComponent = FC<PhosphorIconProps>;

export interface NodeMeta {
  label: string;
  desc: string;
  icon: NodeIconComponent;
  color: string;
  bg: string;
  border: string;
}

export const NODE_META: Record<string, NodeMeta> = {
  load_excel:   { label: '加载 Excel', desc: '从 Excel 文件读取数据',   icon: FileXls,        color: 'text-blue-600',   bg: 'bg-blue-50',   border: 'border-blue-200' },
  load_csv:     { label: '加载 CSV',   desc: '从 CSV 文件读取数据',     icon: Table,          color: 'text-sky-600',    bg: 'bg-sky-50',    border: 'border-sky-200' },
  load_api:     { label: 'API 数据',   desc: '从 HTTP 接口获取数据',    icon: CloudArrowDown, color: 'text-indigo-600', bg: 'bg-indigo-50', border: 'border-indigo-200' },
  filter:       { label: '筛选',       desc: '按条件过滤数据行',        icon: Funnel,         color: 'text-emerald-600',bg: 'bg-emerald-50',border: 'border-emerald-200' },
  sort:         { label: '排序',       desc: '对数据进行排序',          icon: ArrowsDownUp,   color: 'text-purple-600', bg: 'bg-purple-50', border: 'border-purple-200' },
  compute:      { label: '计算列',     desc: '添加自定义计算字段',      icon: Calculator,     color: 'text-teal-600',   bg: 'bg-teal-50',   border: 'border-teal-200' },
  dedup:        { label: '去重',       desc: '删除重复行',              icon: Copy,           color: 'text-cyan-600',   bg: 'bg-cyan-50',   border: 'border-cyan-200' },
  aggregate:    { label: '聚合统计',   desc: '分组汇总计算',            icon: ChartBar,       color: 'text-rose-600',   bg: 'bg-rose-50',   border: 'border-rose-200' },
  group_by:     { label: '分组',       desc: '按字段分组数据',          icon: SquaresFour,    color: 'text-pink-600',   bg: 'bg-pink-50',   border: 'border-pink-200' },
  join:         { label: '关联合并',   desc: '按键关联两个数据集',      icon: ArrowsMerge,    color: 'text-amber-600',  bg: 'bg-amber-50',  border: 'border-amber-200' },
  append:       { label: '追加',       desc: '纵向合并两个数据集',      icon: Stack,          color: 'text-orange-600', bg: 'bg-orange-50', border: 'border-orange-200' },
  diff:         { label: '差异对比',   desc: '对比两数据集差异',        icon: ArrowsLeftRight,color: 'text-violet-600', bg: 'bg-violet-50', border: 'border-violet-200' },
  export_excel: { label: '导出 Excel', desc: '将结果保存为 Excel',      icon: DownloadSimple, color: 'text-zinc-600',   bg: 'bg-zinc-100',  border: 'border-zinc-200' },
  export_csv:   { label: '导出 CSV',   desc: '将结果保存为 CSV',        icon: DownloadSimple, color: 'text-zinc-500',   bg: 'bg-zinc-50',   border: 'border-zinc-200' },
};

export const NODE_PALETTE_CATEGORIES: { label: string; types: string[] }[] = [
  { label: '输入', types: ['load_excel', 'load_csv', 'load_api'] },
  { label: '转换', types: ['filter', 'sort', 'compute', 'dedup'] },
  { label: '聚合', types: ['aggregate', 'group_by'] },
  { label: '合并', types: ['join', 'append'] },
  { label: '对比', types: ['diff'] },
  { label: '输出', types: ['export_excel', 'export_csv'] },
];

/** Returns a hex color string for MiniMap node coloring */
export function getNodeColor(type: string): string {
  const colorMap: Record<string, string> = {
    load_excel: '#bfdbfe', load_csv: '#bae6fd', load_api: '#c7d2fe',
    filter: '#a7f3d0', sort: '#e9d5ff', compute: '#99f6e4', dedup: '#a5f3fc',
    aggregate: '#fecdd3', group_by: '#fbcfe8',
    join: '#fde68a', append: '#fed7aa',
    diff: '#ddd6fe',
    export_excel: '#e4e4e7', export_csv: '#f4f4f5',
  };
  return colorMap[type] ?? '#e4e4e7';
}
